import {afterEveryRender, Component, DOCUMENT, inject, LOCALE_ID} from "@angular/core";
import {RouterLink} from "@angular/router";
import {HeaderComponent} from "../../layout/header/header.component";
import {LargeLogoShearComponent} from "../../layout/large-logo-shear/large-logo-shear.component";

@Component({
  selector: "app-imprint",
  templateUrl: "./imprint.component.html",
  imports: [
    HeaderComponent,
    RouterLink,
    LargeLogoShearComponent,
  ],
})
export class ImprintComponent {
  protected readonly showTelefax = inject(LOCALE_ID) === "de";

  public constructor() {
    const document = inject(DOCUMENT);
    afterEveryRender({
      earlyRead: () => document.getElementById("sg-email-address"),
      write: element => {
        if (!element) return;
        const name = "webmaster";
        const domain = "sersoft.de";
        element.innerText = `${name}@${domain}`;
      },
    });
  }
}
